const LeetCodeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none">
    <path d="M33.2 0C17.6 0 5 13.5 5 30c0 16.5 12.6 30 28.2 30 6.7 0 13-2.5 18.3-7.1l-3.7-3.9C43.9 53 38.8 55 33.2 55 19.9 55 9.4 43.6 9.4 30S20 5 33.2 5c5.6 0 10.7 2 14.7 5.4l3.7-3.9C46.3 2.5 39.9 0 33.2 0zm27.5 23.2L44.2 40.7 38 34.3l4.8-4.9H23.6v7h15.5l-4.8 4.9 6.2 6.4L61 26.9 60.7 24z" fill="#FFA116" />
  </svg>
);

export default LeetCodeIcon;
